import { render } from "./BaseAccordion.vue?vue&type=template&id=8063ac98&scoped=true"
import script from "./BaseAccordion.vue?vue&type=script&lang=js"
export * from "./BaseAccordion.vue?vue&type=script&lang=js"

import "./BaseAccordion.vue?vue&type=style&index=0&id=8063ac98&scoped=true&lang=css"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8063ac98"]])

export default __exports__